import React, { useState, useMemo } from 'react'
import { usePaletteTheme } from '../../../context/paletteTheme'
import DropdownFinancial from '../../visualization-dropdown/DropdownFinancial'
import { Grid, SvgIcon, Paper, Button,  } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DatasetButton from '../../visualization-dropdown/DatasetButton'
import { useSection } from '../../../context/section'
import { NoContent } from '../../../utils/tools'
import useDatasets from '../../../pages/visualization/hooks/useDatasets'
import { DatasetProvider } from '../../../context/dataset'
import ButtonActive from '../../ui/ButtonActive'
import { PlayArrowOutlined, UploadFileOutlined, UploadOutlined } from '@mui/icons-material'
import { Autocomplete, ListSubheader, CircularProgress } from '@mui/material'
import KpiEditor from '../../visualization-dropdown/KpiEditor'
import styles from './ResearchSection.module.scss'
import TextFieldPaper from "../../ui/TextFieldPaper"
import { useEffect } from 'react'
import { GarphProvider } from "../../../context/graphContext"
import NowcastingInsightPanel from '../../correlation/components/NowcastingInsightPanel'
import SampleGraph from '../../SampleGraph'
import { Skeleton } from '@mui/material'
import NowcastingModelDetails from './NowcastingModelDetails'
import axios from 'axios';
import { Col, message, Row, Descriptions, Upload } from "antd"
import dayjs from "dayjs";
import { CSVTOJSON2 } from '../../../utils/commonFunctions'
import UploadCustomKPI from './UploadCustomKPI';

function GridItem(props) {
    return (
        <Grid item xs={6} md={3} {...props}>
            {props.children}
        </Grid>
    )
}

const error = () => { throw new Error('could not get the Nowcasting Data for selected provider') }

const predictdailyOptions=[
    {name: "Predict for Next 1 Day", value:1},
    {name: "Predict for Next 3 Days", value:3},
    // {name: "Predict for Next 7 Days", value:7},
    // {name: "Predict for Next 1 month", value:30},
    // {name: "Predict for Next 3 months", value:90},
]
const predictQuarterlyOptions=[
    {name: "Predict for Next 1 Quarter", value:1},
    {name: "Predict for Next 2 Quarters", value:2},
    // {name: "Predict for Next 4 Quarters", value:4},
    // {name: "Predict for Next 6 Quarters", value:6},
    // {name: "Predict for Next 10 Quarters", value:10},
]

export default function NowcastingVisualization({ticker, sectionId, projectId}) {
    const { selectedData, sectionNowcastingDetails, updateFinancialInfo, UpdateNowcastingModelDetails, getNowcastingModelInfo  } = useSection()
    const { datasets } = useDatasets(ticker)
    const { NowcastingfinancialInfo } = selectedData
    const [datasetoptions, setDatasetOptions] = useState(null)
    const [selectedDatasetInfo, setSelectedDatasetInfo] = useState(null)
    const [selectedPredictInfo, setselectedPredictInfo] = useState(null)
    const [graphId, setGraphId] = useState(sectionNowcastingDetails?.graph_id)
    const [runClicked, setRunClicked] = useState(false);
    const [ShowModelDetails, setShowModelDetails] = React.useState(false); 
    const [ModelDetails, setModelDetails] = useState(null)
    const [loading, setLoading] = useState(false)


    const [UploadFilecheck, setUploadFileCheck] = useState(false);
    const [UploadFileData, setUploadFileData] = useState([]);
    const [UploadFileName, setUploadFileName] = useState(null);
    const [SelectedDateColumn, setSelectedDateColumn] = useState('')
    const [SelectedPredictColumn, setSelectedPredictColumn] = useState(null)
    const [UploadDataFrequency, setUploadDataFrequency] = useState(null)

    
    const renderKPIInput = (params) => (
        <TextFieldPaper
          placeholder="Select..."
          label="Financial KPI"
          variant="filled"
          {...params}
          InputProps={{...params.InputProps, disableUnderline: true}}
        />
      )
    

    const handledatasetChange = (v,e) =>{
        setSelectedDatasetInfo(e)
        UpdateNowcastingModelDetails(v,e,"dataset")
    }

    const handledPredictPeriodChange = (v,e) =>{
        setselectedPredictInfo(e)
        UpdateNowcastingModelDetails(v,e,"period")
    }

    const getGraphFunction = async (data, graphId) => {
        const resJson = await axios({
            method: 'post',
            url: '/api/getNowcastingGraphFunction',
            data: {...data, 'graphId':graphId,'type':'nowcasting'}
        })

        const res = await resJson.data
        return { ...data, fig: res.layers, correlation:res.correlation }
    }   

    const getGraph = async (graphId) => {
        const resJson = await axios.get(`/api/getGraph?graphId=${graphId}`)
        const res = await resJson.data
        return { fig: res.layers, displayMethod: res.displayMethod, timeRange: res.timeRange, timeFrame: res.timeFrame,correlation:res.correlation}
    }


    useEffect(()=>{
        const options = datasets?.map((item,i)=>{
            return {category: "Acive Datasets", category_index: 1+i, index: 1+i, name: item.name, value: item.value, "frequency": item.frequency}
        })
        if (options){
            setDatasetOptions(options)
            setSelectedDatasetInfo(options.find(item=> item.value == sectionNowcastingDetails?.nowcasting_dataset) || null)
            const periodOptios = !['stockPrice','volume'].includes(sectionNowcastingDetails?.nowcasting_financial_info)?predictQuarterlyOptions:predictdailyOptions
            setselectedPredictInfo(
                periodOptios.find(item=> item.value == sectionNowcastingDetails?.nowcasting_predict_value) || null
            )
        }
        if (graphId){
            setRunClicked(false)
        }
        return () => {}
    },[datasets])

    const getNocastingGraphId = async () => {
        try {
            if (!NowcastingfinancialInfo){
                message.error(UploadFilecheck?"Please Select the column for Nowcasting analysis":"Please select Financial or Company Specific KPI for Nowcasting analysis",5)
                return
            }
            if (UploadFilecheck && !SelectedDateColumn){
                message.error("Please select Date Column",5)
                return
            }
            if (UploadFilecheck &&  UploadDataFrequency && ['unknown','weekly','monthly']?.includes(UploadDataFrequency)){
                message.error("Uploaded Custom KPI Data frequency is not supported for Nowcasting analysis. Please upload Daily or Quarterly frequency data.",5)
                return
            }
            if (!selectedDatasetInfo || !selectedDatasetInfo?.value || !selectedDatasetInfo?.name){
                message.error("Please select Dataset",5)
                return
            }
            if (!selectedPredictInfo || !selectedPredictInfo?.value){
                message.error("Please select Predict period ",5)
                return
            }

            setGraphId(null)
            setRunClicked(true); 
            setShowModelDetails(false)
            setModelDetails(null)
            setLoading(true)

            const resJson = await axios({
                method: 'post',
                url: '/api/getNocastingGraph',
                data: {
                        "UploadFilecheck":UploadFilecheck,
                        "UploadFileData":UploadFilecheck?UploadFileData.map(item=>{return{[SelectedDateColumn?.value]:item[SelectedDateColumn?.value],[SelectedPredictColumn?.value]:item[SelectedPredictColumn?.value]}}):null,
                        "UploadFileDateColumn":UploadFilecheck?SelectedDateColumn?.value:null,
                        "uploadFileKPIFrequency":UploadFilecheck? UploadDataFrequency:null,
                        "columnName":sectionNowcastingDetails?.nowcasting_financial_info_name,
                        "columnValue":NowcastingfinancialInfo,
                        "client":selectedDatasetInfo.value,
                        "dataset_name":selectedDatasetInfo.name,
                        "predict_values_count":selectedPredictInfo.value,
                        "ticker":ticker,
                        "section_uuid":sectionId,
                        "projectId":projectId,
                    }
            })
            const res = await resJson.data
            getNowcastingModelInfo(sectionId)
            setGraphId(res['graphId'])
            setLoading(false)
            setRunClicked(false);
        }
        catch { error(); setRunClicked(false);setLoading(false)}
    }

    const renderData = () => (
        graphId ? renderGraphs : runClicked ? <Skeleton width='100%' height='500px'/> : <div className='graph'><NoContent type={"nowcasting"} /></div>
    )

    const initialGraph = {
        fig: null,
        displayMethod:'NONE',
        timeRange: 'ALL',
    } 

    const renderGraphs = useMemo(() => (
        <GarphProvider key={graphId} graphId={graphId} getGraphFunction={getGraphFunction} getGraph={getGraph} initialGraph={initialGraph}>
            <NowcastingInsightPanel />
            <SampleGraph graphId={graphId}/>
        </GarphProvider>
    ), [graphId])

    

    useEffect(()=>{
        if (sectionNowcastingDetails && sectionNowcastingDetails?.model_details){
            let data = sectionNowcastingDetails?.model_details || null
            if(data){
                const Model_Name = data.model
                const temp_data = {"model":Model_Name,...data}                
                const temp = Object.keys(temp_data).filter(item=>!["name",'preds','corr'].includes(item)).map(item=>{
                    if (item == "model") return {key : "Model Name", value : temp_data[item]}
                    if (item == "mape") return {key : "Mean Error", value : parseFloat(temp_data[item]).toFixed(4)}
                    if (item == "predict_from") return {key : "Predict From", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                    if (item == "predict_to") return {key : "Predict To", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                    if (item == "r2") return {key : "R Square", value : parseFloat(temp_data[item]).toFixed(4)}
                    if (item == "test_from") return {key : "Test From", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                    if (item == "test_to") return {key : "Test To", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                    if (item == "train_from") return {key : "Train From", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                    if (item == "train_to") return {key : "Train To", value : dayjs(temp_data[item]).format("YYYY-MM-DD")}
                })
                setModelDetails(temp)
            }
        }
        else{
            setModelDetails(null)
        }
    },[sectionNowcastingDetails,ShowModelDetails,runClicked])


    useEffect(()=>{
        setSelectedDatasetInfo(null)
        setselectedPredictInfo(null)
    },[NowcastingfinancialInfo])  
    
    useEffect(()=>{
        (SelectedPredictColumn&&updateFinancialInfo(null, SelectedPredictColumn, "nowcasting"))
    },[SelectedPredictColumn])

  

    return (
        <div>
            <div className={styles["choose-data-header"]}>
                <Row gutter={[18,18]}>

                    {UploadFilecheck&&
                        <Col span={24} >
                                    <Paper style={{padding:'10px', backgroundColor:'transparent', display:'flex', alignItems:'center', border:'0.2px dashed orange'}}>
                                <SvgIcon component={UploadFileOutlined} style={{ fontSize: 40, marginRight:'10px' }} />
                                <div>
                                    <div style={{fontSize:'16px', fontWeight:'550'}}>Custom KPI Data Uploaded - {UploadFileName}</div>
                                    <div style={{fontSize:'14px', color:'gray'}}>You have successfully uploaded a custom KPI dataset for nowcasting analysis.</div>
                                    <div style={{fontSize:'14px', color:'orange'}}>To select a Standard/Company Specific KPI, please remove the current file and select from the dropdown.</div>
                                </div>                                
                            </Paper>
                        </Col>
                    }

                    {!UploadFilecheck&&
                        <Col span={12} >
                            <DropdownFinancial financialInfo={NowcastingfinancialInfo}  ticker={ticker} type={"nowcasting"}/>
                        </Col>
                    }
                        
                    <UploadCustomKPI 
                        UploadFilecheck={UploadFilecheck} 
                        setUploadFileCheck={setUploadFileCheck} 
                        setUploadFileData={setUploadFileData} 
                        setUploadFileName={setUploadFileName} 
                        SelectedDateColumn={SelectedDateColumn} 
                        SelectedPredictColumn={SelectedPredictColumn} 
                        setSelectedPredictColumn={setSelectedPredictColumn} 
                        setSelectedDateColumn={setSelectedDateColumn} 
                        setUploadDataFrequency={setUploadDataFrequency}
                    />
                    
                    <Col span={6} style={{display:'flex',justifyContent:'flex-end'}}>
                        <ButtonActive style={{height: '48px',backgroundColor:'#dccb03', color:'black'}} variant="contained" size="large" startIcon={!loading?<PlayArrowOutlined style={{ fontSize: 30 }}/>:<CircularProgress size = "25px" style={{ color:"black"}}/>} onClick={getNocastingGraphId} >Run Nowcasting</ButtonActive>
                    </Col>
                    
                    <Col span={24}>
                        <Grid container spacing={3}>
                            {datasetoptions&&<GridItem>
                                <Autocomplete
                                    options={['stockPrice','volume'].includes(NowcastingfinancialInfo)?datasetoptions.filter(item=>item.frequency == "daily"):datasetoptions}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params)=>renderKPIInput({...params,label:'Dataset'})}
                                    disableClearable
                                    loading={!datasetoptions}
                                    value={selectedDatasetInfo}
                                    onChange={(v,e) =>{handledatasetChange(v,e)}}
                                    fullWidth
                                    groupBy={(option) => option.category}
                                />
                                </GridItem>
                            }
                            {datasetoptions&&<GridItem>
                                <Autocomplete
                                    options={!['stockPrice','volume'].includes(NowcastingfinancialInfo)?predictQuarterlyOptions:predictdailyOptions}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params)=>renderKPIInput({...params,label:'Predict Period'})}
                                    disableClearable
                                    loading={!datasetoptions}
                                    value={selectedPredictInfo}
                                    onChange={(v,e) =>{handledPredictPeriodChange(v,e)}}
                                    fullWidth
                                />
                                </GridItem>
                            }
                        </Grid>
                </Col>
                </Row>
            </div>

            {renderData()}

            <div style={{marginTop:"20px"}}>
                <Paper >
                    <Button 
                        variant="outlined" 
                        startIcon={!ShowModelDetails?<ArrowDropDownIcon fontSize="large" />:<ArrowDropUpIcon fontSize="large"/>} 
                        style={{display:'flex',justifyContent:'center',padding:'10px',width:'100%'}}
                        onClick={()=>{
                            setShowModelDetails(!ShowModelDetails)
                            }}
                    >Show Nowcasting Model Details
                    </Button>
                    {graphId&&ShowModelDetails&&ModelDetails&&ModelDetails.length&&
                    <div style={{padding:'15px'}}>
                        {/* <NowcastingModelDetails graphId={graphId} ModelDetails={ModelDetails} ShowModelDetails={ShowModelDetails} /> */}
                        <Descriptions
                            title=""
                            bordered
                            column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
                            items={ModelDetails.map(item=>{return{"label":item['key'],"children":item['value']}})}
                        />                    
                    </div>
                    }
                </Paper>
            </div> 


        </div>
    )
}
